var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*eslint no-useless-escape: 0*/
import React, { useState, useEffect, useMemo } from 'react';
import { Box, Button, IconButton, Typography, Grid, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from '@mui/material';
import { MODOS, MENSAGENS, getDataFormatada, validarData, parseDate } from '../../../../../utils';
import { ROUTES, FUNCIONALIDADES } from '../../../../../routes';
import { BoxBotoes } from '../../../../../components/form_box';
import Loading from '../../../../../components/loading';
import { useParams } from 'react-router-dom';
import { BotaoFechar, BotaoAuxiliar } from '../../../../../components/botoes';
import { InputDados } from '../../../../../components/input_dados';
import { ModeEditOutlined as ModeEditOutlinedIcon, DeleteOutline as DeleteOutlineIcon } from '@mui/icons-material';
import GridComp from '../../../../../components/grid';
import { alterarObservacaoADM as alterarObservacaoADMAPI, cadastrarObservacaoADM, excluirObservacaoADM, getReeducandoObservacoesADM, STATUS_API, } from './services';
import { useAuth } from '../../../../../contexts/auth/AuthContext';
export var ReeducandosObservacoesADM = function (props) {
    var _a = useAuth(), User = _a.User, getAcoesFuncionalidade = _a.getAcoesFuncionalidade;
    var AcoesFuncionalidade = useMemo(function () { return getAcoesFuncionalidade(FUNCIONALIDADES.REEDUCANDOS_OBSERVAÇÕES_ADM); }, [getAcoesFuncionalidade]);
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(true), LoadingInicio = _c[0], setLoadingInicio = _c[1];
    var _d = useParams(), id = _d.id, modo = _d.modo;
    var _e = useState([]), ObservacoesADMReeducando = _e[0], setObservacoesADMReeducando = _e[1];
    var _f = useState(''), Titulo = _f[0], setTitulo = _f[1];
    var _g = useState(''), Data = _g[0], setData = _g[1];
    var _h = useState(''), Observacao = _h[0], setObservacao = _h[1];
    var _j = useState(false), PopupAberto = _j[0], setPopupAberto = _j[1];
    var _k = useState(), EditarID = _k[0], setEditarID = _k[1];
    var _l = useState(), EditarTitulo = _l[0], setEditarTitulo = _l[1];
    var _m = useState(''), EditarData = _m[0], setEditarData = _m[1];
    var _o = useState(''), EditarObservacao = _o[0], setEditarObservacao = _o[1];
    var _p = useState(''), EditarUsuarioNome = _p[0], setEditarUsuarioNome = _p[1];
    var setAbaAtiva = props.setAbaAtiva;
    var PODE_CADASTRAR = !!AcoesFuncionalidade['CADASTRAR'];
    var PODE_EDITAR = !!AcoesFuncionalidade['ALTERAR'];
    var PODE_EXCLUIR = !!AcoesFuncionalidade['EXCLUIR'];
    var DESABILITAR_CAMPOS = modo == MODOS.VISUALIZAR || modo == MODOS.EXCLUIR || !(PODE_EDITAR || PODE_CADASTRAR);
    var podeEditarObservacao = PODE_EDITAR && !DESABILITAR_CAMPOS;
    useEffect(function () {
        carregarDados();
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var RespReeducando, observacoes_adm;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!id) return [3 /*break*/, 2];
                    return [4 /*yield*/, getReeducandoObservacoesADM(id)];
                case 1:
                    RespReeducando = _a.sent();
                    if (RespReeducando.Status == STATUS_API.ERRO) {
                        alert(RespReeducando.Mensagem);
                        return [2 /*return*/];
                    }
                    else {
                        observacoes_adm = RespReeducando.observacoes_adm;
                        setObservacoesADMReeducando(observacoes_adm);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    alert('ID do Colaborador não informado');
                    _a.label = 3;
                case 3:
                    setLoadingInicio(false);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var validarDados = function () {
        if (!Titulo || Titulo.trim() == '') {
            alert("Titulo ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!Data || Data.trim() == '') {
            alert("Data ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!validarData(Data)) {
            alert("Data ".concat(MENSAGENS.PREENCHIMENTO_INVALIDO));
            return false;
        }
        return true;
    };
    var validarDadosEditar = function () {
        if (!EditarTitulo || EditarTitulo.trim() == '') {
            alert("Titulo ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!EditarData || EditarData.trim() == '') {
            alert("Data ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!validarData(EditarData)) {
            alert("Data ".concat(MENSAGENS.PREENCHIMENTO_INVALIDO));
            return false;
        }
        return true;
    };
    var adicionarObservacaoADM = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Dados, Resp, observacoes_adm;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!validarDados())
                        return [2 /*return*/];
                    setLoading(true);
                    Dados = {
                        titulo: Titulo,
                        data: parseDate(Data),
                        observacao: Observacao,
                    };
                    return [4 /*yield*/, cadastrarObservacaoADM(Dados, id !== null && id !== void 0 ? id : '')];
                case 1:
                    Resp = _a.sent();
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        observacoes_adm = Resp.dados.observacoes_adm;
                        setObservacoesADMReeducando(observacoes_adm !== null && observacoes_adm !== void 0 ? observacoes_adm : []);
                        limparSelecao();
                    }
                    else {
                        alert(Resp.Mensagem);
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var alterarObservacaoADM = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Dados, Resp, ObservacoesADMAtualizados;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!validarDadosEditar())
                        return [2 /*return*/];
                    setLoading(true);
                    Dados = {
                        titulo: EditarTitulo,
                        data: parseDate(EditarData),
                        observacao: EditarObservacao,
                    };
                    return [4 /*yield*/, alterarObservacaoADMAPI(Dados, EditarID ? EditarID.toString() : '')];
                case 1:
                    Resp = _a.sent();
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        ObservacoesADMAtualizados = ObservacoesADMReeducando.map(function (Item) {
                            if (Item.id == EditarID) {
                                return __assign(__assign({}, Item), Dados);
                            }
                            else {
                                return Item;
                            }
                        });
                        setObservacoesADMReeducando(ObservacoesADMAtualizados);
                        setPopupAberto(false);
                        limparPopup();
                    }
                    else {
                        alert(Resp ? Resp.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function (row) { return __awaiter(void 0, void 0, void 0, function () {
        var id, autor_id, Resp, ObservacoesADMAtualizados;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    id = row.id, autor_id = row.autor_id;
                    if (autor_id != (User === null || User === void 0 ? void 0 : User.id)) {
                        alert('Você não tem permissão para excluir essa observação');
                        return [2 /*return*/];
                    }
                    if (!confirm(MENSAGENS.EXCLUIR_REGISTRO)) return [3 /*break*/, 2];
                    setLoading(true);
                    return [4 /*yield*/, excluirObservacaoADM(id)];
                case 1:
                    Resp = _a.sent();
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        ObservacoesADMAtualizados = ObservacoesADMReeducando.filter(function (Item) { return Item.id != +id; });
                        setObservacoesADMReeducando(ObservacoesADMAtualizados);
                    }
                    else {
                        setLoading(false);
                        alert(Resp ? Resp.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setLoading(false);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var limparSelecao = function () {
        setTitulo('');
        setData('');
        setObservacao('');
    };
    var limparPopup = function () {
        setEditarID(undefined);
        setEditarTitulo('');
        setEditarData('');
        setEditarObservacao('');
    };
    var COLUNAS_TERMOS = [
        {
            field: 'titulo',
            headerName: 'Título',
            width: 300,
        },
        {
            field: 'data',
            headerName: 'Data',
            width: 150,
            valueGetter: function (value) { return getDataFormatada(value); },
        },
        {
            field: 'autor_id',
            headerName: 'Autor',
            width: 250,
            valueGetter: function (_value, row) { var _a; return (_a = row.autor) === null || _a === void 0 ? void 0 : _a.nome; },
        },
        {
            field: 'observacao',
            headerName: 'Observação',
            width: 350,
        },
        {
            field: 'Opções',
            headerName: '',
            align: 'right',
            flex: 1,
            minWidth: 80,
            renderCell: function (params) { return (_jsxs(Box, __assign({ flex: 1, display: 'flex', justifyContent: 'flex-end' }, { children: [_jsx(Tooltip, __assign({ title: podeEditarObservacao ? 'Editar' : 'Usuário sem permissão para editar', componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx("span", { children: _jsx(Box, __assign({ sx: {
                                    borderRadius: '50%',
                                    width: 25,
                                    height: 25,
                                    margin: 0.5,
                                    bgcolor: podeEditarObservacao ? 'primary.main' : 'action.disabledBackground',
                                    opacity: podeEditarObservacao ? 1 : 0.6,
                                    cursor: podeEditarObservacao ? 'pointer' : 'not-allowed',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                } }, { children: _jsx(IconButton, __assign({ size: 'small', onClick: podeEditarObservacao ? function () { var _a; return abrirPopup((_a = params.row) === null || _a === void 0 ? void 0 : _a.id); } : undefined, disabled: !podeEditarObservacao, sx: { padding: 0, cursor: podeEditarObservacao ? 'pointer' : 'not-allowed' } }, { children: _jsx(ModeEditOutlinedIcon, { sx: {
                                            color: podeEditarObservacao ? 'white' : 'action.disabled',
                                            fontSize: 18,
                                            marginBottom: '5px',
                                            paddingBottom: '5px',
                                        } }) })) })) }) })), _jsx(Box, __assign({ bgcolor: 'error.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () { return handleDelete(params.row); }, disabled: DESABILITAR_CAMPOS || !PODE_EXCLUIR }, { children: _jsx(DeleteOutlineIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) }))] }))); },
        },
    ];
    var abrirPopup = function (ObservacaoADMID) { return __awaiter(void 0, void 0, void 0, function () {
        var ObservacaoADMAux, id_1, titulo, data, observacao, autor;
        return __generator(this, function (_a) {
            setLoading(true);
            ObservacaoADMAux = ObservacoesADMReeducando.find(function (Item) { return Item.id == +ObservacaoADMID; });
            if (ObservacaoADMAux) {
                id_1 = ObservacaoADMAux.id, titulo = ObservacaoADMAux.titulo, data = ObservacaoADMAux.data, observacao = ObservacaoADMAux.observacao, autor = ObservacaoADMAux.autor;
                setEditarID(id_1);
                setEditarTitulo(titulo);
                setEditarData(getDataFormatada(data));
                setEditarObservacao(observacao);
                setEditarUsuarioNome(autor === null || autor === void 0 ? void 0 : autor.nome);
            }
            setLoading(false);
            setPopupAberto(true);
            return [2 /*return*/];
        });
    }); };
    var handleClose = function () {
        if (confirm('Tem certeza que deseja sair?')) {
            setPopupAberto(false);
        }
    };
    return (_jsx(_Fragment, { children: !LoadingInicio && (_jsxs(_Fragment, { children: [_jsxs(Box, __assign({ mt: 5 }, { children: [_jsx(Typography, __assign({ variant: 'h6', gutterBottom: true }, { children: "Observa\u00E7\u00E3o Administrativa" })), _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, sm: 4 }, { children: _jsx(InputDados, { id: 'titulo', label: 'T\u00EDtulo', value: Titulo, onChange: function (event) { return setTitulo(event.target.value); }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 4 }, { children: _jsx(InputDados, { id: 'data', label: 'Data', mask: '99/99/9999', value: Data, onChange: function (event) { return setData(event.target.value); }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 12 }, { children: _jsx(Grid, __assign({ item: true, xs: 12, sm: 4 }, { children: _jsx(InputDados, { id: 'observacao', label: 'Observa\u00E7\u00E3o', value: Observacao, onChange: function (event) { return setObservacao(event.target.value); }, multiline: true, maxRows: 4, disabled: DESABILITAR_CAMPOS }) })) })), _jsxs(Grid, __assign({ item: true, xs: 12, sm: 12 }, { children: [_jsx(BotaoAuxiliar, __assign({ onClick: limparSelecao, backgroundColor: 'error.main', disabled: DESABILITAR_CAMPOS }, { children: "Limpar" })), _jsx(BotaoAuxiliar, __assign({ sx: { ml: 1 }, onClick: adicionarObservacaoADM, backgroundColor: 'principal.main', disabled: DESABILITAR_CAMPOS || !AcoesFuncionalidade['CADASTRAR'] }, { children: "Adicionar" }))] }))] })), _jsx(Box, __assign({ mt: 8 }, { children: _jsx(GridComp, { rows: ObservacoesADMReeducando, columns: COLUNAS_TERMOS, loading: loading, paginationMode: 'client', onPaginationModelChange: function () { } }) })), _jsxs(BoxBotoes, __assign({ sx: { marginTop: 10 } }, { children: [_jsx(BotaoAuxiliar, __assign({ backgroundColor: 'terceary.main', onClick: function () { return setAbaAtiva(7); } }, { children: "Voltar" })), _jsx(BotaoFechar, { modo: modo, pagina: ROUTES.REEDUCANDOS })] }))] })), _jsxs(Dialog, __assign({ open: PopupAberto, onClose: handleClose, maxWidth: 'sm', fullWidth: true }, { children: [_jsx(DialogTitle, { children: "Editar Observa\u00E7\u00E3o Administrativa" }), _jsxs(DialogContent, __assign({ style: { margin: 5, padding: 10 } }, { children: [_jsx(Box, __assign({ mb: 2, mt: 2 }, { children: _jsx(InputDados, { id: 'id', label: 'ID', value: EditarID, disabled: true }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'titulo', label: 'T\u00EDtulo', value: EditarTitulo, onChange: function (event) { return setEditarTitulo(event.target.value); }, disabled: !PODE_EDITAR }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'data', label: 'Data', mask: '99/99/9999', value: EditarData, onChange: function (event) { return setEditarData(event.target.value); }, disabled: !PODE_EDITAR }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'observacao', label: 'Observa\u00E7\u00E3o', value: EditarObservacao, onChange: function (event) { return setEditarObservacao(event.target.value); }, multiline: true, maxRows: 4, disabled: !PODE_EDITAR }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'autor', label: 'Autor', value: EditarUsuarioNome, disabled: true }) }))] })), _jsxs(DialogActions, __assign({ style: { padding: 20 } }, { children: [_jsx(Button, __assign({ onClick: handleClose }, { children: "Cancelar" })), _jsx(Button, __assign({ onClick: alterarObservacaoADM, variant: 'contained', color: 'primary', disabled: !PODE_EDITAR }, { children: "Salvar" }))] }))] })), loading && _jsx(Loading, {})] })) }));
};
export default ReeducandosObservacoesADM;
